export class submitOTPLabel_EN {

    dialog: {
        refNumber: string;
        message: string;
        otp: string;
        number: string;
        regenerate: string;
        successDisplay: string;
        send: string;
        verifyMobile: string;
        verifyEmail: string;
        verifyEmailMasked: string;
        verifiedEmailSuccess: string;
        verifiedMobileSuccess: string;
    }

    button: {
        submit: string;
        resend: string;
        submitLater: string;
        okText: string;
        regenerate: string;
    }

    constructor() {

        this.dialog = {
            refNumber: "  DLP Reference number: ",
            message: " is generated. You may submit the approval for getting a quote anytime later.",
            otp: " OTP has been generated for Quotation number: ",
            // number: "and sent to customer’s mobile number ending with ******",
            number: "and sent to your mobile number ending with ******",
            regenerate: "OTP maximum retries reached, please regenerate",
            successDisplay: " Quotation has been submitted. Application number is ",
            send: "",
            verifyMobile: "One Time Password has been shared to your mobile number ending with ******",
            verifyEmail: "One Time Password has been shared to your email ID",
            verifyEmailMasked: "****",
            verifiedEmailSuccess: "Email ID verified Successfully",
            verifiedMobileSuccess: "Mobile number verified Successfully",
        }
        this.button = {
            submit: "Submit OTP Now ",
            resend: "Resend OTP",
            submitLater: "Submit OTP Later ",
            okText: "OK",
            regenerate: "Re-Generate OTP "
        }
    }
}
